import React from "react";
import "./QuoteSection.css";

function QuoteSection() {
  return (
    <div className="quote-section">
      <blockquote className="quote-text">
        Photography is the story I fail to put into words.
      </blockquote>
    </div>
  );
}

export default QuoteSection;
